module.exports = __webpack_public_path__ + "static/media/parvane2.42ae48b9.jpg";